import { useMemo } from 'react';
import type { WidgetSize } from '../../types/dashboard';
import { BucketPerformanceList } from './BucketPerformanceList';
import {
  MOVEMENT_BUCKETS,
  buildBucketPerformance,
  getTradeMovementPct,
} from '../../lib/trades/dashboardBucketAnalytics';

export const PerformanceByMovementWidget = ({
    timeRange,
    size,
    trades = [],
}: {
    timeRange: 'week' | 'month' | 'year';
    size: WidgetSize;
    trades?: any[];
}) => {
    const perfData = useMemo(
        () => buildBucketPerformance({ trades, timeRange, buckets: MOVEMENT_BUCKETS, metric: getTradeMovementPct }),
        [timeRange, trades]
    );

    return <BucketPerformanceList result={perfData} size={size} labelWidthClass="w-28" pctFormatter={(item) => `${item.pct.toFixed(2)}%`} />;
};